module.exports = __webpack_public_path__ + "img/3.d6af0e41.jpg";